import React__default from 'react';
import { SvgImg } from '../../../components/svgImg/svgImg.js';
import { circle, percentageStyle } from './ClubProgress.style.js';

const PercentageLoader = ({ width = '60', height = '60', fill = '#DEDEDE', percentage, formattedPercentage, }) => {
    const dashArray = `${percentage}, 100`;
    return (React__default.createElement(SvgImg, { viewbox: "0 0 36 36", title: "PercentageLoader", width: width, height: height, fill: fill },
        React__default.createElement("path", { style: circle, stroke: fill, strokeDasharray: dashArray, d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" }),
        React__default.createElement("circle", { opacity: "0.20", cx: "18", cy: "17.8085", r: "12", fill: "transparent", stroke: fill, strokeWidth: "2.5" }),
        React__default.createElement("text", { x: "19", y: "20.5", style: percentageStyle, fill: fill },
            formattedPercentage,
            React__default.createElement("tspan", null, "%"))));
};

export { PercentageLoader };
